<lib-bottom-sheet [settings]="offlineModeSheetSettings" [open]="open()" contentBackground="transparent" (closed)="handleSheetClosed()" (dismissed)="handleSheetDismissed()">
  <div class="function-picture-container">
    <img [src]="useDarkMode$$() ? 'assets/icons/dark/offline.svg' : 'assets/icons/light/offline.svg'" alt="" />
  </div>
  <div class="description">
    <h3>{{ 'offlineMode.modal.title' | transloco }}</h3>
    {{ 'offlineMode.modal.message' | transloco }}
  </div>
  <ion-buttons>
    <lib-app-button data-testid="update-status-button" expand="block" fill="outline" (click)="handleUpdateStatus()">
      <ion-icon name="reload" slot="start"></ion-icon>
      {{ 'offlineMode.modal.buttons.updateStatus' | transloco }}
    </lib-app-button>
    @if (isNativePlatform) {
      <lib-app-button data-testid="go-system-settings-button" expand="block" fill="solid" (click)="handleGoToSystemSettings()">
        <ion-icon name="open-in-new" slot="end"></ion-icon>
        {{ 'offlineMode.modal.buttons.goSystemSettings' | transloco }}
      </lib-app-button>
    }
  </ion-buttons>
</lib-bottom-sheet>
